import { theme } from 'theme/theme';
import { WS_STATUSES } from './Commercial.constants';

export const StatusConfig = {
    [WS_STATUSES.AVAILABLE]: {
        value: WS_STATUSES.AVAILABLE,
        name: 'Available',
        borderColor: theme.color.green,
        color: 'black',
    },
    [WS_STATUSES.IN_SERVICE]: {
        value: WS_STATUSES.IN_SERVICE,
        name: 'In Service',
        borderColor: theme.color.yellow,
        color: 'black',
    },
    [WS_STATUSES.STOPPED]: {
        value: WS_STATUSES.STOPPED,
        name: 'Stopped',
        borderColor: theme.color.brown,
        color: 'black',
    },

    [WS_STATUSES.ALARM_RUNNING]: {
        value: WS_STATUSES.ALARM_RUNNING,
        name: 'Alarm: Running',
        borderColor: theme.color.orange,
        color: 'black',
    },
    [WS_STATUSES.CURTAILED]: {
        value: WS_STATUSES.CURTAILED,
        name: 'Curtailed',
        borderColor: theme.color.blue,
        color: 'black',
    },
    [WS_STATUSES.NO_COMM]: {
        value: WS_STATUSES.NO_COMM,
        name: 'No comms',
        borderColor: theme.color.red,
        color: 'black',
    },

    [WS_STATUSES.STOPPED_MANUAL]: {
        value: WS_STATUSES.STOPPED_MANUAL,
        name: 'Stopped: Manual',
        borderColor: theme.color.pink,
        color: 'black',
    },

    [WS_STATUSES.ALARM_STOPPED]: {
        value: WS_STATUSES.ALARM_STOPPED,
        name: 'Alarm: Stopped',
        borderColor: '#b20f0f',
        color: 'white',
    },
};
